var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00928 22.8707C6.00928 19.7318 6.93983 16.7179 8.80094 13.829C10.6621 10.9401 13.2176 8.41236 16.4676 6.2457C17.0787 5.82903 17.7107 5.8082 18.3634 6.1832C19.0162 6.5582 19.3426 7.1207 19.3426 7.8707V10.0374C19.3426 10.9818 19.669 11.7735 20.3218 12.4124C20.9746 13.0513 21.7732 13.3707 22.7176 13.3707C23.1898 13.3707 23.6412 13.2665 24.0718 13.0582C24.5023 12.8499 24.8843 12.5513 25.2176 12.1624C25.4398 11.8846 25.7246 11.711 26.0718 11.6415C26.419 11.5721 26.7454 11.6485 27.0509 11.8707C28.8009 13.1207 30.1759 14.7179 31.1759 16.6624C32.1759 18.6068 32.6759 20.6763 32.6759 22.8707C32.6759 25.3151 32.0787 27.5443 30.8843 29.5582C29.6898 31.5721 28.1204 33.1624 26.1759 34.329C26.6482 33.6624 27.0162 32.9332 27.2801 32.1415C27.544 31.3499 27.6759 30.5096 27.6759 29.6207C27.6759 28.5096 27.4676 27.461 27.0509 26.4749C26.6343 25.4888 26.0371 24.6068 25.2593 23.829L19.3426 18.0374L13.4676 23.829C12.6621 24.6346 12.0509 25.5235 11.6343 26.4957C11.2176 27.4679 11.0093 28.5096 11.0093 29.6207C11.0093 30.5096 11.1412 31.3499 11.4051 32.1415C11.669 32.9332 12.0371 33.6624 12.5093 34.329C10.5648 33.1624 8.99539 31.5721 7.80094 29.5582C6.6065 27.5443 6.00928 25.3151 6.00928 22.8707ZM19.3426 22.704L22.8843 26.1624C23.3565 26.6346 23.7176 27.1624 23.9676 27.7457C24.2176 28.329 24.3426 28.954 24.3426 29.6207C24.3426 30.9818 23.8565 32.1415 22.8843 33.0999C21.9121 34.0582 20.7315 34.5374 19.3426 34.5374C17.9537 34.5374 16.7732 34.0582 15.8009 33.0999C14.8287 32.1415 14.3426 30.9818 14.3426 29.6207C14.3426 28.9818 14.4676 28.3638 14.7176 27.7665C14.9676 27.1693 15.3287 26.6346 15.8009 26.1624L19.3426 22.704Z",
    fill: "url(#paint0_linear_6386_88378)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6386_88378",
    x1: 19.3426,
    y1: 5.91675,
    x2: 19.3426,
    y2: 34.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#FF7D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FDA704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#FFC15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F163"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire-icon.cc0111549e3125978d2fa780db916a44.svg";
export { ForwardRef as ReactComponent };